module.exports = __webpack_public_path__ + "24182523c55614a5167496de0ed8de19.fbx";